import { Link } from 'react-router-dom';
import { paths } from '../lib/paths';

interface CompanyPlaceholderPageProps {
  title: string;
  eyebrow: string;
  description: string;
}

export function CompanyPlaceholderPage({
  title,
  eyebrow,
  description,
}: CompanyPlaceholderPageProps) {
  return (
    <div className="card" style={{ maxWidth: 760, padding: 28 }}>
      <div className="eyebrow">{eyebrow}</div>
      <h1 style={{ margin: '6px 0 0', fontSize: 30 }}>{title}</h1>
      <p className="muted" style={{ maxWidth: 640, marginTop: 10 }}>{description}</p>
      <div className="row" style={{ gap: 10, marginTop: 18 }}>
        <Link to={paths.companyHome} className="btn btn--primary">
          Back to Scorekeeper HQ
        </Link>
        <Link to={paths.companyPipeline} className="btn">
          Pipeline
        </Link>
      </div>
    </div>
  );
}
